import { render } from "./VUEPopupModificaGraficoBanda.vue?vue&type=template&id=6c291e94"
import script from "./VUEPopupModificaGraficoBanda.vue?vue&type=script&lang=js"
export * from "./VUEPopupModificaGraficoBanda.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__